module.exports = "pegasus_template/assets/backdrop.png";